
import React from 'react';
import { formatCurrency } from '@/lib/utils';

interface ShippingOptionProps {
  id: string;
  name: string;
  price: number;
  days: string;
  selected: boolean;
  currency: string;
  onSelect: (id: string) => void;
}

const ShippingOption: React.FC<ShippingOptionProps> = ({
  id,
  name,
  price,
  days,
  selected,
  currency,
  onSelect,
}) => {
  return (
    <div 
      className={`flex items-center justify-between p-3 border rounded-md cursor-pointer ${
        selected ? 'border-ahavex-blue bg-blue-50' : 'border-gray-200'
      }`}
      onClick={() => onSelect(id)}
    >
      <div className="flex items-center">
        <div className={`w-5 h-5 rounded-full border flex items-center justify-center mr-3 ${
          selected ? 'border-ahavex-blue' : 'border-gray-300'
        }`}>
          {selected && (
            <div className="w-3 h-3 rounded-full bg-ahavex-blue" />
          )}
        </div>
        <div>
          <div className="font-medium">{name}</div>
          <div className="text-sm text-gray-500">Delivery in {days} business days</div>
        </div>
      </div>
      <div>
        {price === 0 ? (
          <span className="text-green-600 font-medium">Free</span>
        ) : (
          <span>{formatCurrency(price, currency)}</span>
        )}
      </div>
    </div>
  );
};

export default ShippingOption;
